import '../sass/citrus-woocommerce-product-gallery.scss';

(() => {
    const $citrusWoocommerceProductGalleries = document.querySelectorAll('.citrus-woocommerce-product-gallery');

    if (!$citrusWoocommerceProductGalleries) return;

    $citrusWoocommerceProductGalleries.forEach($citrusWoocommerceProductGallery => {
        const $carousel = $citrusWoocommerceProductGallery.querySelector('.citrus-woocommerce-product-gallery__carousel');
        const $carouselNavBtns = $citrusWoocommerceProductGallery.querySelectorAll('.citrus-woocommerce-product-gallery__thumbnail-btn');

        const initCarousel = () => {
            if (!$carousel) return;

            const carousel = new Swiper($carousel, {
                keyboard: {
                    enabled: true,
                },
                loop: true,
                autoHeight: true,
            });

            if ($carouselNavBtns) {
                $carouselNavBtns.forEach($carouselNavBtn => {
                    $carouselNavBtn.addEventListener('click', () => {
                        const $activeCarouselNavBtn = $citrusWoocommerceProductGallery.querySelector('.citrus-woocommerce-product-gallery__thumbnail-btn--active');

                        const { index } = $carouselNavBtn.dataset;

                        $activeCarouselNavBtn.classList.remove('citrus-woocommerce-product-gallery__thumbnail-btn--active');
                        $carouselNavBtn.classList.add('citrus-woocommerce-product-gallery__thumbnail-btn--active');

                        console.log(index);

                        carousel.slideTo(index);
                    });
                });
            }
        };

        initCarousel();
    });
})();
